<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      issue_types: [],
      IssueTypes: {},
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchIssueTypes: null,
      IssueTypesSearchMode: false,
      // appprices:[]
    };
  },
  methods: {
    addIssueTypes() {
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "popups.name",
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("issue-types", obj).then((res) => {
                if (res.status) this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editIssueType(record) {
      var value = Object.assign({}, record);
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: "popups.name",
            value: value.name,
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("issue-types", record.id, obj).then((res) => {
                if (res.status) this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search(page) {
      if (!this.searchIssueTypes.length) return this.cancelappsearchMode();
      this.IssueTypesSearchMode = true;
      this.http
        .post("issue-types/search", {
          page,
          limit: this.limit,
          search: this.searchIssueTypes,
          col: "name",
        })
        .then((res) => {
          if (res.status) {
            this.page = page;
            this.tot_pages = Math.ceil(res.tot / this.limit);
            this.issue_types = res.data;
          }
        });
    },
    cancelappsearchMode() {
      this.searchIssueTypes = "";
      this.IssueTypesSearchMode = false;
      this.get(this.page);
    },
    getIssueTypes() {
      this.http.get("issue-types").then((res) => {
        this.issue_types = res.data;
      });
    },
    deleteIssueTypes(app) {
      var data = {
        title: "popups.delete",
        template: `
          <h5>${this.$t("popups.delmessage")}</h5>

        `,
        buttons: [
          {
            text: "Delete",
            closer: true,
            color: "danger",
            handler: () => {
              console.log(app);
              this.http.delete("issue-types", app.id).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "Cancel",
            closer: true,
            color: "light",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    get(page) {
      console.log(page);
      this.http
        .post("issue-types/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.issue_types = res.data;
        });
    },
  },
  created() {
    this.get(1);
    this.getIssueTypes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menu.menuitems.crm.subItems.issue_types')" />

    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchIssueTypes"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          type="button"
          @click="addIssueTypes()"
          class="btn btn-light float-end mb-4"
          data-bs-toggle="modal"
          data-bs-target="#Add"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">#</th>
          <th scope="col">{{ $t("popups.name") }}</th>
          <th scope="col">{{ $t("popups.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app, index) in issue_types" :key="app" class="text-center">
          <td>{{ index + 1 }}</td>

          <td>{{ app.name }}</td>

          <td>
            <div class="d-flex justify-content-center">
              <a
                class="btn btn-primary me-2"
                @click="editIssueType(app)"
                href="javascript: void(0);"
                role="button"
                >{{ $t("popups.edit") }}</a
              >
              <a
                class="btn btn-danger me-2"
                href="javascript: void(0);"
                role="button"
                @click="deleteIssueTypes(app)"
                >{{ $t("popups.delete") }}</a
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <!--end-->
    <!--   Apps  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchIssueTypes ? search(page - 1) : get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchIssueTypes ? search(p) : get(p)"
          >{{ p }}</a
        >
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="searchIssueTypes ? search(page + 1) : get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>
